import styled from 'styled-components';

export const Measure = styled.div`
  background: white;
  min-height: 100%;
`
